/* eslint-disable canonical/filename-match-regex */
import { defineMessages } from 'react-intl';

export const bestsellerSliderMessages = defineMessages({
    bestsellerProducts: { defaultMessage: 'Beliebte Erlebnisse' },
    bestsellerShowMore: { defaultMessage: 'Mehr entdecken' },
});

export const categoryMessages = defineMessages({
    fly: {
        defaultMessage: 'Fliegen & Fallen',
    },
    travel: {
        defaultMessage: 'Reisen & Kurzurlaub',
    },
    car: {
        defaultMessage: 'Motorpower',
    },
    sport: {
        defaultMessage: 'Abenteuer & Sport',
    },
    dinner: {
        defaultMessage: 'Essen & Trinken',
    },
    health: {
        defaultMessage: 'Wellness & Gesundheit',
    },
    art: {
        defaultMessage: 'Kunst, Kultur & Lifestyle',
    },
    surf: {
        defaultMessage: 'Wasser & Wind',
    },
    animals: {
        defaultMessage: 'Erlebnisse mit Tieren',
    },
    fireworks: {
        defaultMessage: 'Erlebnistage',
    },
    tv: {
        defaultMessage: 'Digitale Erlebnisse',
    },
});

export const lastSeenSliderMessages = defineMessages({
    lastSeenProducts: { defaultMessage: 'Zuletzt gesehen' },
});

export const productSliderMessages = defineMessages({
    showAll: {
        defaultMessage: 'Alle anzeigen',
    },
});

export const productTileMessages = defineMessages({
    a11YPdpRedirection: { defaultMessage: 'Weiterleitung zur Produkt Detail Seite' },
    onlineExperienceLocation: { defaultMessage: 'Online-Erlebnis' },
    multipleLocations: { defaultMessage: 'an {locationCount} Orten' },
    participantsLabel: {
        defaultMessage: '{participants} {maxCount, plural, one {Person} other {Personen}}',
    },
    screenReaderTextForWishlistRemove: { defaultMessage: 'Von der Wunschliste entfernen' },
    screenReaderTextForWishlistAdd: { defaultMessage: 'Zur Wunschliste hinzufügen' },
    tooManyWishlistArticlesError: {
        defaultMessage:
            'Die maximale Anzahl an Erlebnissen wurde erreicht – bitte entferne Artikel, um Platz für neue zu schaffen.',
    },
    servicesCaptionMessage: { defaultMessage: 'Details' },
    a11yCloseServicesMessage: { defaultMessage: 'Leistungsbeschreibung schließen' },
    close: {
        defaultMessage: 'Schließen',
    },
    pricePrefix: { defaultMessage: 'ab' },
});

export const relatedProductMessages = defineMessages({
    relatedProducts: { defaultMessage: 'Andere Produkte entdecken' },
});
